module.exports = __webpack_public_path__ + "static/media/apti_space_CDPHP_logo.add4210e.svg";